import { render, staticRenderFns } from "./Video-2.vue?vue&type=template&id=2e38598d&scoped=true"
import script from "./Video-2.vue?vue&type=script&lang=js"
export * from "./Video-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e38598d",
  null
  
)

export default component.exports